
<template>
    <div class="article-list">
      <article v-for="article in articles" :key="article.id">
        <h2>{{ article.title }}</h2>
        <p>{{ article.summary }}</p>
        <router-link :to="`/article/${article.id}`">阅读更多</router-link>
      </article>
    </div>
  </template>
  
  <script setup>
  const articles = [
    { id: 1, title: 'Vue 3 入门指南', summary: '学习 Vue 3 的基础知识和核心概念。' },
    { id: 2, title: '响应式布局技巧', summary: '掌握如何创建响应式网页布局。' },
    { id: 3, title: '旅行日记：日本之行', summary: '分享在日本旅行的精彩经历。' },
  ];
  </script>
  
  <style scoped>
  .article-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
    padding: 1rem;
  }
  
  article {
    border: 1px solid #ddd;
    padding: 1rem;
    border-radius: 4px;
  }
  
  article h2 {
    margin-top: 0;
  }
  
  @media (max-width: 768px) {
    .article-list {
      grid-template-columns: 1fr;
    }
  }
  </style>